export const SYSTEM_ROLE_LABELS = {
  master: "마스터",
  admin: "관리자",
  manager: "매니저",
  user: "일반 사용자",
};

export function normalizeSystemRole(role) {
  return String(role ?? "")
    .trim()
    .toLowerCase();
}

export function formatSystemRole(role) {
  const normalized = normalizeSystemRole(role);
  if (!normalized) return "-";
  return SYSTEM_ROLE_LABELS[normalized] ?? "알 수 없음";
}
